import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type {
  CoverageByCriteriaRequest,
  CoverageFilters,
  CoverageListRequest,
} from 'types'

import {
  coverageCount,
  coverageGet,
  coverageGetByCriteria,
  coverageList,
} from './coverage.service'

export const coverageKeyFactory = {
  base: () => ['coverages'],
  list: (request?: CoverageListRequest) => [
    ...coverageKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  count: (filters?: CoverageFilters) => [
    ...coverageKeyFactory.base(),
    'count',
    ...(filters ? [filters] : []),
  ],
  get: (coverageUuid?: string) => [
    ...coverageKeyFactory.base(),
    ...(coverageUuid ? [coverageUuid] : []),
  ],
  getByCriteria: (request?: CoverageByCriteriaRequest) => [
    ...coverageKeyFactory.base(),
    'by-criteria',
    ...(request ? [request] : []),
  ],
}

export const queryCoverageList = (request: CoverageListRequest) =>
  queryOptions({
    queryKey: coverageKeyFactory.list(request),
    queryFn: () => coverageList(request),
    placeholderData: keepPreviousData,
  })

export const queryCoverageCount = (filters?: CoverageFilters) =>
  queryOptions({
    queryKey: coverageKeyFactory.count(filters),
    queryFn: () => coverageCount(filters),
    placeholderData: keepPreviousData,
  })

export const queryCoverageGet = (coverageUuid: string) =>
  queryOptions({
    queryKey: coverageKeyFactory.get(coverageUuid),
    queryFn: () => coverageGet(coverageUuid),
  })

export const queryCoverageGetByCriteria = (
  request: CoverageByCriteriaRequest,
) =>
  queryOptions({
    queryKey: coverageKeyFactory.getByCriteria(request),
    queryFn: () => coverageGetByCriteria(request),
    placeholderData: keepPreviousData,
  })
